import React, { useEffect, useState } from "react";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import { Table, Button, Pagination, Icon } from "semantic-ui-react";
import {
  Container,
  Content,
  Center,
  ContainerPaginate,
  InputSearch,
} from "./styled";
import { producaov2 as api } from "../../../../services/apis";
import { FaUserPlus } from "react-icons/fa";
import ModalSubmit from "../../../../components/Admin/Pagarme/ModalSubmit";
import ModalCreatePlan from "../../../../components/Admin/Pagarme/ModalCreatePlan";
import { getUserNode } from "../../../../services/auth_node";
import swal from "sweetalert";
import { useRouter } from "../../../../hooks/router";
import { godPrivUsers } from "../../../../utils/Utils";

const PagarmePlanos = () => {
  const [plans, setPlans] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [plano, setPlano] = useState(null);
  const [modalPlan, setModalPlan] = useState(false);
  const [totalPages, setTotalPages] = useState(100);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");

  const route = useRouter();

  const getInitialPlans = async () => {
    const res = await api.get(`/pagarme/plan`);
    setPlans(res.data);
  };

  const handleFilterByName = async () => {
    const res = await api.get(`/pagarme/plan?name=${search}&size=100`);
    setPlans(res.data);
  };

  const handlePageChange = async (event, data) => {
    const newPage = data.activePage;
    const res = await api.get(`/pagarme/plan?page=${newPage}`);
    if (res.data.length === 0) {
      setTotalPages(newPage - 1);
    } else {
      setPlans(res.data);
      setPage(newPage);
    }
  };

  const handleOpen = (plan) => {
    setPlano(plan);
    setModalOpen(true);
  };

  const handleClose = () => {
    setPlano(null);
    setModalOpen(false);
  };

  useEffect(() => {
    const user = getUserNode();

    const isGodPrivUser = godPrivUsers.users;

    if (!isGodPrivUser.includes(user.email)) {
      swal(
        "Você não tem permissão para acessar essa página",
        "Voce sera redirecionando para a home",
        "warning"
      ).then(() => {
        route.push("/admin");
      });
      return;
    }

    getInitialPlans();
  }, [modalOpen, modalPlan]);

  return (
    <>
      <AdminMenu />
      <Container>
        <Content>
          <Center space>
            <h1>Planos Pagarme</h1>
            <Button
              type="button"
              color="orange"
              onClick={() => setModalPlan(true)}
            >
              Cadastrar novo plano
            </Button>
          </Center>

          <InputSearch className="ui fluid left icon input">
            <input
              placeholder="Busque pelo nome do plano"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyUp={(e) => {
                if (e.key === "Enter") {
                  handleFilterByName();
                }
              }}
            />
            <Icon name="search icon" />
            <button onClick={() => handleFilterByName()}>Buscar</button>
          </InputSearch>

          <Table stackable>
            <Table.Header>
              <Table.HeaderCell>ID</Table.HeaderCell>
              <Table.HeaderCell>Nome</Table.HeaderCell>
              <Table.HeaderCell>Descrição</Table.HeaderCell>
              <Table.HeaderCell>Preço</Table.HeaderCell>
              <Table.HeaderCell>Criar plano para aluno</Table.HeaderCell>
            </Table.Header>
            <Table.Body>
              {plans.length > 0 ? (
                plans.map((plan, key) => (
                  <Table.Row key={key}>
                    <Table.Cell>{plan.id}</Table.Cell>
                    <Table.Cell>{plan.name}</Table.Cell>
                    <Table.Cell>{plan.description}</Table.Cell>
                    <Table.Cell>
                      R${plan.price.slice(0, -2)},{plan.price.substr(-2)}
                    </Table.Cell>
                    <Table.Cell>
                      <Center>
                        <Button onClick={() => handleOpen(plan)}>
                          <FaUserPlus />
                        </Button>
                      </Center>
                    </Table.Cell>
                  </Table.Row>
                ))
              ) : (
                <Table.Cell>Nenhum plano cadastrado</Table.Cell>
              )}
            </Table.Body>
          </Table>
        </Content>

        <ModalSubmit
          open={modalOpen}
          handleClose={handleClose}
          idPlano={plano?.id}
        />
        <ModalCreatePlan open={modalPlan} handleClose={setModalPlan} />
      </Container>
      <ContainerPaginate>
        <Pagination
          defaultActivePage={1}
          ellipsisItem={null}
          // siblingRange={1}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          page={page}
        />
      </ContainerPaginate>
    </>
  );
};

export default PagarmePlanos;
